// was once a part of the debug module, but moved here for exposing it globally as vl.pprint()
import { isObject, mapItems, dict } from 'ldash';
import { isElement } from 'react-is';
export const PPRINT_BUFFER = {
    data: null,
    expanded: null
};
export const set_pprint_buffer = (data, expanded = null)=>{
    /* changes are collected by watchPPrintBuffer saga
   */ if (isObject(data)) {
        // hashObj will be used, and that will crash on react elements
        data = dict(mapItems(data, (k, v)=>[
                k,
                isElement(v) ? '<FILTERED_REACT>' : v
            ]));
    }
    PPRINT_BUFFER.data = data;
    PPRINT_BUFFER.expanded = expanded;
};
